import React, { useRef } from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { HashLink } from 'react-router-hash-link';

function Header() {
  const ref=useRef()
  const handleClick=()=>{
    if(document.body.clientWidth <992){
      ref.current.click()
    }
  }
  return (
    <div className='Header'>
      <>
        {['lg'].map((expand) => (
          <Navbar key={expand} expand={expand} className="bg-body-tertiary">
            <Container fluid>
              <Navbar.Brand href="/" ><span className='color-red'>Fit With Hepi</span></Navbar.Brand>
              <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} ref={ref}/>
              <Navbar.Offcanvas
                id={`offcanvasNavbar-expand-${expand}`}
                aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                placement="end"
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  Fit With Hepi
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Nav className="justify-content-end flex-grow-1 pe-3">
                    <div className='headerLink'>
                      <HashLink to="/" className='sideLink' onClick={handleClick}>
                        Home
                      </HashLink>
                    </div>
                    <div className='headerLink'>
                      <HashLink to='/#onlineclub' className='sideLink' onClick={handleClick}>
                        Online Club
                      </HashLink>
                    </div>
                    <div className='headerLink'>
                      <HashLink to='/#workout' className='sideLink' onClick={handleClick}>
                        Live Workout
                      </HashLink>
                    </div>
                    <div className='headerLink'>
                      <a href='/#photos' className='sideLink' onClick={handleClick}>
                        Photos
                      </a>
                    </div>
                    <div className='headerLink'>
                      <HashLink to='/#Offlineclub' className='sideLink' onClick={handleClick}>
                        Offline Club
                      </HashLink>
                    </div>
                    <div className='headerLink'>
                      <HashLink to='/#dietplanning' className='sideLink' onClick={handleClick}>
                        Diet Planning
                      </HashLink>
                    </div>
                    <div className='headerLink'>
                      <HashLink to='/contactus/#contactus' className='sideLink' onClick={handleClick}>
                        Register Now
                      </HashLink>
                    </div>
                  </Nav>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Container>
          </Navbar>
        ))}
      </>
    </div>
  )
}

export default Header
